import type { DataLayer } from '../../types/dataLayer'

export const addDataLayer = (dataLayer: DataLayer) => {
	window.dataLayer = window.dataLayer || []
	window.dataLayer.push(...dataLayer)
}
